import {
    GET_LIST,
    GET_MANY,
    GET_ONE,
    GET_MANY_REFERENCE,
    CREATE,
    UPDATE,
    DELETE
} from 'react-admin';
import { hotlineBlocklistFields } from "./hotlineBlocklist.model";
import queryString from 'query-string';
import { getApiUrlForResource } from '../services/apiUrlResolver';

export const HOTLINE_BLOCKLIST_RESOURCE_NAME = "hotline-blocklist";

// Helper function to get API URL at request time - hotline blocklist uses calls flag
const getApiUrl = () => getApiUrlForResource('calls');

const providerRequestToHttpRequest = (requestType, requestParams) => {
    switch (requestType) {
        case GET_LIST: 
            return composeGetHotlineBlocklistListRequest(requestParams);
        case GET_ONE:
            return { url: `${getApiUrl()}/hotline/blocklist/${requestParams.id}` };
        case GET_MANY: {
            const query = {
                filter: JSON.stringify({ id: requestParams.ids }),
            };
            return { url: `${getApiUrl()}/hotline/blocklist?${queryString.stringify(query)}` };
        }
        case GET_MANY_REFERENCE: {
            const { page, perPage } = requestParams.pagination;
            const { field, order } = requestParams.sort;
            const query = {
                sort: JSON.stringify([field, order]),
                range: JSON.stringify([(page - 1) * perPage, (page * perPage) - 1]),
                filter: JSON.stringify({ ...requestParams.filter, [requestParams.target]: requestParams.id }),
            };
            return { url: `${getApiUrl()}/hotline/blocklist?${queryString.stringify(query)}` };
        }
        case UPDATE:
            return {
                url: `${getApiUrl()}/hotline/blocklist/${requestParams.id}`,
                options: { method: 'PUT', body: JSON.stringify(requestParams.data) },
            };
        case CREATE:
            return {
                url: `${getApiUrl()}/hotline/blocklist`,
                options: { method: 'POST', body: JSON.stringify(requestParams.data) },
            };
        case DELETE:
            return {
                url: `${getApiUrl()}/hotline/blocklist/${requestParams.id}`,
                options: { method: 'DELETE', body: JSON.stringify(requestParams.data) }
            };
        default:
            throw new Error(`Unsupported fetch action type ${requestType}`);
    }
};

const httpResponseToProviderData = (httpResponse, requestType, requestParams) => {
    let { headers, json } = httpResponse;
    switch (requestType) {
        case GET_LIST:
            return {
                data: json.map(item => item),
                total: parseInt(headers.get('content-range').split('/').pop()),
            };
        case GET_MANY:
            let idsToGet = requestParams.ids;
            return {
                data: json.filter(item => idsToGet.includes(item.id))
            };
        case CREATE:
            return { data: { ...requestParams.data, id: json.id } };
        default:
            return { data: json };
    }
};

const composeGetHotlineBlocklistListRequest = (requestParams) => {
    const { page, perPage } = requestParams.pagination;
    const { field, order } = requestParams.sort;
    
    let prepareFilters = () => {
        let requestFilters = requestParams.filter;
        if (requestFilters === undefined) {
            return {};
        }

        let createContainsFilter = (name, value) => ({ name, comparison: "contains", value });
        let createEqualsFilter = (name, value) => ({ name, comparison: "equals", value });

        let resultFilters = [];
        
        // Phone number filter
        if (requestFilters.hasOwnProperty(hotlineBlocklistFields.phoneNumber)) {
            resultFilters.push(createContainsFilter('phoneNumber', requestFilters[hotlineBlocklistFields.phoneNumber]));
        }
        
        // TX hotline filter
        if (requestFilters.hasOwnProperty(hotlineBlocklistFields.appliesToTx)) {
            resultFilters.push(createEqualsFilter('appliesToTx', requestFilters[hotlineBlocklistFields.appliesToTx]));
        }
        
        // TN hotline filter
        if (requestFilters.hasOwnProperty(hotlineBlocklistFields.appliesToTn)) {
            resultFilters.push(createEqualsFilter('appliesToTn', requestFilters[hotlineBlocklistFields.appliesToTn]));
        }
        
        // Date range filters
        if (requestFilters.hasOwnProperty('createdBetween')) {
            const { from, to } = requestFilters.createdBetween;
            if (from) {
                resultFilters.push({ name: 'createdAt', comparison: 'gte', value: from });
            }
            if (to) {
                resultFilters.push({ name: 'createdAt', comparison: 'lte', value: to });
            }
        }
       
        return resultFilters;
    };

    const queryParams = {
        sort: JSON.stringify([field, order]),
        range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
        filters: JSON.stringify(prepareFilters()),
    };
    return { url: `${getApiUrl()}/hotline/blocklist?${queryString.stringify(queryParams)}` };
}

export default {
    resource: HOTLINE_BLOCKLIST_RESOURCE_NAME,
    providerInterface: {
        providerRequestToHttpRequest,
        httpResponseToProviderData
    },
}; 